module.exports = __webpack_public_path__ + "static/media/gallery27.b65f9e13.png";